import { NotePalette } from './NotePalette';
import type { NoteColors, NoteId } from '../types';

interface Props {
  colors: NoteColors;
  selectedNote: NoteId;
  onNoteSelect: (note: NoteId) => void;
  soundEnabled: boolean;
}

/** Panel lateral: paleta de notas. Las figuras se eligen en la barra contextual del tiempo. */
export function MelodySidePanels({
  colors,
  selectedNote,
  onNoteSelect,
  soundEnabled,
}: Props) {
  return (
    <aside className="melody-panels" aria-label="Herramientas de edición">
      <section className="melody-panel melody-panel--notes">
        <h2 className="melody-panel__title">Notas</h2>
        <div className="melody-panel__body">
          <NotePalette
            colors={colors}
            selected={selectedNote}
            onSelect={onNoteSelect}
            soundEnabled={soundEnabled}
            variant="melody"
            layout="vertical"
          />
        </div>
      </section>
    </aside>
  );
}
